import { render, staticRenderFns } from "./TheToolbarDesktop.vue?vue&type=template&id=5ae6cdaa&scoped=true"
import script from "./TheToolbarDesktop.vue?vue&type=script&lang=ts"
export * from "./TheToolbarDesktop.vue?vue&type=script&lang=ts"
import style0 from "./TheToolbarDesktop.vue?vue&type=style&index=0&id=5ae6cdaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae6cdaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAvatar,VBadge,VBtn,VCard,VCardText,VIcon,VImg,VMenu,VSpacer,VToolbar,VToolbarItems,VToolbarTitle})
